export default class WaiversPlayersHelper {
  constructor(waiversData) {
    this.data = waiversData;
  }

  /**
   *
   * @param playerId
   * @returns {null|Date}
   */
  getClearDueDate(playerId) {
    if (!this.isOnWaivers(playerId)) return null;

    return this.data.waivers.players[playerId].clearDueDate;
  }

  /**
   *
   * @param playerId
   * @returns {boolean}
   */
  isOnWaivers(playerId) {
    return this.data.waivers.players.hasOwnProperty(playerId);
  }
}
